
  import VueRouter from 'vue-router';
  import { Component, Vue } from 'vue-property-decorator'
  import { inject } from 'inversify-props'
  import { IAuthService } from '@/services'
  import { types } from '@/store'
  import { routePaths, demoRoutes, testRoutes } from '@/router'
  import colorlogo from '@/components/svg/Cartewheel-MealCounter-color.svg';
  import { eventBus, mcEvents, mcDate, mcStatus, mcLogger } from '@/utils';

  @Component({ components: { colorlogo } })
  export default class Home extends Vue {
    @inject() private authService!: IAuthService;
    @inject() private router!: VueRouter;

    devMode: boolean = mcStatus.isInDevMode();
    console: Console = mcLogger.getConsole(this.constructor.name, 'pink');

    message: string = '';
    get isOnline() {
      return this.$store.getters[types.state.isOnline];
    }

    get appConfigSettings() {
      return this.$store.getters[types.state.appConfigSettings];
    }

    async login() {
      const isAuth = await this.authService.isAuthenticated();
      if (!isAuth && !this.authService.isLogout) {
        if (navigator.onLine) {
          this.message = "You are not logged in. You will be redirected to log in.";
          eventBus.$emit(mcEvents.sessionTimedOut);
          this.authService.startLogin();
        }
        else {
          this.router.push(routePaths.offline.path);
        }
      }
      else {
        this.router.push(routePaths.dashboard.path);
      }
    }

    async goToAdmin() {
      if (this.$store.state.counter.isOnline) {
        const timezone = mcDate.timeZone();
        const adminUrl = this.$store.state.auth.appConfigSettings.adminUrl;
        location.replace(`${adminUrl}Users/UserLogin?localTimezone=${timezone}`);
      }
      else {
        this.router.push(routePaths.offline.path);
      }
    }

    async goToComponentDemos() {
      this.router.push(demoRoutes.paths.home.path);
    }

    async goToTests() {
      this.router.push(testRoutes.paths.home.path);
    }

    get isCountingAppEnabled(): boolean {
      let isEnabled = false;
      isEnabled = this.appConfigSettings?.featureFlags?.countingAppEnabled ?? false;
      return isEnabled;
    }
  }
